import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CmsCommonModule } from 'src/app/cms/common/common.module';
import { ListModule } from '../list/list.module';
import { EmbedDialogComponent } from './embed-dialog.component';
import { PanelComponent } from './panel.component';
import { PanelService } from './panel.service';
import { CoursePanel } from './panels/course-panel';
import { FlashCardPanel } from './panels/flash-card-panel';
import { FlashCardStackPanel } from './panels/flash-card-stack-panel';
import { QuestionPanel } from './panels/question-panel';
import { QuizPanel } from './panels/quiz-panel';
import { StatisticsModule } from '../statistics/statistics.module';
import { ImportResultBottomSheetComponent } from './import-result-bottom-sheet.component';
import { ExamPanel } from './panels/exam-panel';
import { ExamQuestionPanel } from './panels/exam-question-panel';
import { ImportSnackBarComponent } from './import-snack-bar.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { EditModule } from '../edit/edit.module';
import { MatTableModule } from '@angular/material/table';
import { ImportFlashCardCsvComponent } from './csv-imports/import-flash-card-csv/import-flash-card-csv.component';
import { ImportQuestionsCsvComponent } from './csv-imports/import-questions-csv/import-questions-csv.component';
import { ImportQuestionCsvErrorDialogComponent } from './csv-imports/import-questions-csv/import-question-csv-error-dialog/import-question-csv-error-dialog.component';
import { PanelImportItemsComponent } from './panel-import-items.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ErrorImportCourseJsonDialogComponent } from './error-import-course-json-dialog.component';
import { CmsPrintFlashCardStackComponent } from './cms-print-flash-card-stack/cms-print-flash-card-stack.component';
import { EventsPanel } from './panels/events-panel';
import { EventQuestionPanel } from './panels/event-question-panel';
import { CopyLinkDialogComponent } from './copy-link-dialog/copy-link-dialog.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  providers: [
    CoursePanel,
    ExamPanel,
    ExamQuestionPanel,
    FlashCardPanel,
    FlashCardStackPanel,
    PanelService,
    QuestionPanel,
    QuizPanel,
    EventsPanel,
    EventQuestionPanel,
  ],
  imports: [
    CmsCommonModule,
    SharedModule,
    EditModule,
    CommonModule,
    MatTableModule,
    DragDropModule,
    ListModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatListModule,
    MatProgressBarModule,
    MatMenuModule,
    MatRadioModule,
    MatSidenavModule,
    MatRippleModule,
    MatSnackBarModule,
    MatTooltipModule,
    StatisticsModule,
    MatSlideToggleModule,
    EmbedDialogComponent,
    ImportResultBottomSheetComponent,
    ImportSnackBarComponent,
    PanelComponent,
    ImportFlashCardCsvComponent,
    ImportQuestionsCsvComponent,
    ImportQuestionCsvErrorDialogComponent,
    PanelImportItemsComponent,
    ErrorImportCourseJsonDialogComponent,
    CmsPrintFlashCardStackComponent,
    CopyLinkDialogComponent,
  ],
  exports: [PanelComponent],
})
export class PanelModule {}
